import { Box, styled } from '@mui/material';

export const PaginationFooterContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
});
